import { getPageType } from '../../../routing';
import type { Sections } from '../../../routing/pages/settings';
import type { PageType } from '../../../routing/types';

const sectionNames: Set<Sections> = new Set([
  'apps',
  'billing',
  'branding',
  'groups',
  'notifications',
  'plan',
  'profile',
  'projects',
  'usage',
  'users',
  'workspaces',
  'actions',
  'webhooks',
  'storage',
]);

export function getPageTypeWithSettingsSections(
  pathname: string
): Sections | PageType {
  const pageType = getPageType(pathname);
  if (pageType !== 'settings') return pageType;
  const parts = pathname.split('/');
  const sectionName: Sections = parts[2] as Sections;

  return sectionNames.has(sectionName) ? sectionName : 'settings';
}
